const initialState = {
  lang:"en",
  mode:"day",
  cookie:false,
};

export const reducer1 = (state = initialState, action) => {
  switch (action.type) {
    case 'changeLangReducer':
      return { ...state, lang: state.lang === "en" ? "jp" : "en"};
    case 'changeModeReducer':
      return { ...state, mode: state.mode === "day" ? "night" : "day"};
    case 'changeCookieReducer':
      return { ...state, cookie: state.cookie === true ? false : true};
    default:
      return state;
  }
};
